import styles from './styles.module.scss';
import { Tooltip } from '@mui/material';
import * as React from 'react';
import { useState } from 'react';
import { ReactComponent as CopyIcon } from '../../assets/images/copy-2.svg';

interface Props {
  employeeId: string;
  fontSize?: string;
}

export const TooltipEmployeeId = ({ employeeId, fontSize = '14px' }: Props) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyEmployeeIdToClipboard = async () => {
    if ('clipboard' in navigator && employeeId) {
      return await navigator.clipboard.writeText(employeeId);
    } else {
      return document.execCommand('copy', true, employeeId);
    }
  };

  const handleCopyClick = () => {
    if (employeeId) {
      copyEmployeeIdToClipboard()
        .then(() => {
          setIsCopied(true);
          setTimeout(() => {
            setIsCopied(false);
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <Tooltip
      classes={{
        popper: styles.tooltipPopper,
        tooltip: styles.tooltip,
      }}
      title={
        <>
          <CopyIcon />
          <span>{isCopied ? 'Copied!' : 'Click to Copy'}</span>
        </>
      }
    >
      <span
        className={styles.employeeId}
        style={{ fontSize }}
        onClick={handleCopyClick}
      >
        {employeeId}
      </span>
    </Tooltip>
  );
};
